<header class="app-header">
  <div class="header-container">
    
    <!-- Logo à gauche -->
    <div class="header-left">
      <img 
        src="assets/images/AtlineServices.png" 
        alt="Atline Services" 
        class="logo"
        routerLink="/"
      >
    </div>

    <!-- Séparateur vertical -->
    <div class="header-divider"></div>

    <!-- Date et heure à droite -->
    <div class="header-right">
      <div class="clock-container">
        <svg class="clock-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <circle cx="12" cy="12" r="10" stroke-width="2"/>
          <path d="M12 6v6l4 2" stroke-width="2" stroke-linecap="round"/>
        </svg>
        
        <div class="datetime">
          <div class="date">{{ currentDate }}</div>
          <div class="time">{{ currentTime }}</div>
        </div>
      </div>
    </div>

  </div>
  
  <!-- Ligne horizontale en bas -->
  <div class="header-bottom-line"></div>
</header>